import type { Status } from '@/types/board';
import { STATUS_CYCLE, COLUMN_BY_ID } from '@/config/columns';
import './StatusToggle.css';

/**
 * Checkbox that advances through new -> active -> hold -> done.
 *
 * Shared by the task rows on a board card and the story rows in the Tasks view,
 * so the two can never disagree about what clicking a status dot does.
 */
export function StatusToggle({
  status,
  onAdvance,
  disabled,
  size,
}: {
  status: Status;
  onAdvance: (next: Status) => void;
  disabled?: boolean;
  /** `lg` is used for story rows, which are taller than a task row. */
  size?: 'sm' | 'lg';
}) {
  const next = STATUS_CYCLE[(STATUS_CYCLE.indexOf(status) + 1) % STATUS_CYCLE.length];
  return (
    <button
      className={`status-toggle ${status}${size === 'lg' ? ' lg' : ''}`}
      disabled={disabled}
      title={`${COLUMN_BY_ID[status].title} — click for ${COLUMN_BY_ID[next].title}`}
      aria-label={`Status: ${COLUMN_BY_ID[status].title}`}
      onClick={(e) => {
        e.stopPropagation();
        onAdvance(next);
      }}
    />
  );
}
